import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Common } from "@root/components/common/CommonTypes";
import PickDateRange, { PickDateRangeResult } from "@root/components/popups/PickDateRange";
import GS from "@root/ts/GlobalSetting";
import { getViewportName } from "@root/ts/sframe/ViewportRoot";
import { Emitter } from "strict-event-emitter";

export default class DateInput extends ComponentBase implements Common.InputComponent
{
  emitter: Emitter<{ change: [value: string, isOk: boolean]; }>;
  _isOk: boolean = false;
  _value: string;
  date: moment.Moment;

  constructor(elem: ComponentElem)
  {
    super(elem);
    this.emitter = new Emitter();

    ///@ts-ignore
    let maxYear = moment().year();

    this.$root.on("click", (event: JQuery.ClickEvent) =>
    {
      event.preventDefault();

      PickDateRange.instance.requestSingle(
        getViewportName() === "mobile" ? null : this.$root[0],
        this.date,
        // undefined,
        undefined,
        {
          showDropdowns: true,
          minYear: 1900,
          maxYear: maxYear,
        }).then((result: PickDateRangeResult) =>
        {
          if(!result) return;

          if (result.start) {

            this.date = result.start;
            this.update();
          }
        });
    });
  }

  update()
  {
    if (this.date) {
      this._value = this.date.format(GS.DATE_FORMAT);
      this.$root.val(this.date.locale("zh-tw").format("LL"));
    }
    else {
      this._value = "";
      this.$root.val("");
    }
    this.emitter.emit("change", this.getValue(), this.isOk());
  }

  getValue()
  {
    return this._value;
  }

  setValue(dateString: string)
  {
    ///@ts-ignore
    let newDate = moment(dateString, GS.DATE_FORMAT);

    this.date = newDate;
    this.update();
  }

  isOk()
  {
    return Boolean(this._value);
  }

  reset(): void
  {
    this.date = undefined;
    this.update();
  }
}